/* eslint-disable */
import React, { useState, useEffect } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { Stack, Card, TextField, IconButton, Grid } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { AddBox } from '@material-ui/icons';
import { AlertDialog } from './../../Common/AlertDialog';
import _ from 'lodash';

export const CustomFixedDeductionTableTable = ({ finalFixdedDeductionTable, setFinalFixdedDeductionTable }) => {
    const [isMaxEror, setIsMaxEror] = useState({});
    const [maxErrorMsg, setMaxErrorMsg] = useState({});
    const [isMinEror, setIsMinEror] = useState({});
    const [minErrorMsg, setMinErrorMsg] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [ApprovedPopUp, setApprovedPopUp] = useState();
    const [message, setMessage] = useState('Confirmation');
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [pickingData, setPickingData] = useState({
        noOfPickings: 1
    });

    useEffect(() => {
        generateFixdedDeductionTable()
    }, [pickingData.noOfPickings]);

    function generateFixdedDeductionTable() {

        var array = [...finalFixdedDeductionTable];
        let model = {
            fixedDeductionName: "",
            fixedDeductionValue: 0,
            rowIndex: array.length + 1
        };
        array.push(model);

        setFinalFixdedDeductionTable(array)
    }

    function handleDelete(e, rowIndex) {
        var array = [...finalFixdedDeductionTable];
        var index = array.findIndex(obj => obj.rowIndex === rowIndex);
        array.splice(index, 1);
        for (let i = 0; i < array.length; i++) {
            array[i] = {
                ...array[i],
                rowIndex: i,
                fixedDeductionName: array[i].fixedDeductionName,
                fixedDeductionValue: array[i].fixedDeductionValue
            }
        }
        setFinalFixdedDeductionTable(array);
    }

    function changeText(e, rowID, inputType) {
        const target = e.target;
        const value = target.value
        const newArr = [...finalFixdedDeductionTable];
        var idx = newArr.findIndex(e => e.rowIndex == parseInt(rowID));

        if (inputType == "fixedDeductionName") {
            newArr[idx] = { ...newArr[idx], fixedDeductionName: value == "" ? "" : value };
        }
        else if (inputType == "fixedDeductionValue") {
            checkQuntityValue(value, idx)
            newArr[idx] = { ...newArr[idx], fixedDeductionValue: value == "" ? parseInt(0) : parseFloat(value) };
        }
        setFinalFixdedDeductionTable(newArr);
    }

    function checkQuntityValue(value, id) {
        var pattern = /^[0-9]+([.][0-9]{0,2})?$/;

        var copyOfMaxErrMsgs = maxErrorMsg;
        var copyOfIsMaxEror = isMaxEror;

        copyOfIsMaxEror[id] = id;
        setIsMaxEror(copyOfIsMaxEror);

        if (value <= 0) {
            copyOfMaxErrMsgs[id] = "Quantity need to be greater than 0.";
        } else if (value.length === 0) {
            copyOfMaxErrMsgs[id] = "Quantity cannot be empty.";
        } else if (!pattern.test(value.toString())) {
            copyOfMaxErrMsgs[id] = "Quantity only allow numbers.";
        } else {
            copyOfMaxErrMsgs[id] = "";

            copyOfIsMaxEror[id] = -1;
            setIsMaxEror(copyOfIsMaxEror);
        }
        setMaxErrorMsg(copyOfMaxErrMsgs);
    }

    function confirmData(y) {
        if (y) {
            handleDelete(y);
        }
    }
    async function confirmMessage(e, rowIndex) {
        setIsLoading(true);
        setEnableConfirmMessage(true);
        setApprovedPopUp(e, rowIndex);
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }

    return (
        <>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} width={263}>
                <IconButton aria-label="add" onClick={() => generateFixdedDeductionTable()} >
                    <AddBox />
                </IconButton>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }}>
                <Card style={{ justifycontent: 'center', width: '150rem' }} >
                    <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Deduction Name</TableCell>
                                    <TableCell align="center">Value</TableCell>
                                    {finalFixdedDeductionTable.length > 1 ?
                                        <TableCell align="center">Action</TableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {finalFixdedDeductionTable.map((object) => {
                                    let ID = object.rowIndex
                                    return (
                                        <TableRow >
                                            <TableCell align="center">
                                                <Grid alignContent={'center'}>
                                                    <TextField
                                                        style={{ width: '10rem' }}
                                                        variant="outlined"
                                                        size={"small"}
                                                        value={object.fixedDeductionName}
                                                        onChange={(e) => changeText(e, object.rowIndex, "fixedDeductionName")}
                                                    />
                                                </Grid>
                                                {(parseInt(isMinEror[ID]) === parseInt(ID)) ?
                                                    <small style={{ color: 'red', wordWrap: 'break-word' }}>{minErrorMsg[ID]}</small> : null
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                <Grid alignContent={'center'}>
                                                    <TextField
                                                        style={{ width: '7rem' }}
                                                        variant="outlined"
                                                        size={"small"}
                                                        name={ID}
                                                        onChange={(e) => changeText(e, object.rowIndex, "fixedDeductionValue")}
                                                        value={object.fixedDeductionValue}
                                                        onKeyDown={(evt) =>
                                                            (evt.key === "-") && evt.preventDefault()
                                                        }
                                                        InputProps={{
                                                            inputProps: {
                                                                step: 0.01,
                                                                type: 'number',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                {(parseInt(isMaxEror[ID]) === parseInt(ID)) ?
                                                    <small style={{ color: 'red', wordWrap: 'break-word' }}>{maxErrorMsg[ID]}</small> : null
                                                }
                                            </TableCell>
                                            <TableCell align="center">
                                                {finalFixdedDeductionTable.length > 1 ?
                                                    <IconButton aria-label="delete" onClick={(e) => confirmMessage(e, object.rowIndex)} >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                    : null}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div hidden={true}>
                        <Grid item>
                            <AlertDialog
                                confirmData={confirmData}
                                headerMessage={message}
                                viewPopup={EnableConfirmMessage}
                                discription={'Are you sure want to Delete Fixed Deduction ?'}
                                setViewPopup={setEnableConfirmMessage}
                            />
                        </Grid>
                    </div>
                </Card>
                <br />
            </Stack>
        </>
    );
}